"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var _IdentityProvider = _interopRequireDefault(require("./models/IdentityProvider"));

var _SamlSettings = _interopRequireDefault(require("./models/SamlSettings"));

var _UserExemption = _interopRequireDefault(require("./models/UserExemption"));

var _settings, _handleActions;

var initialState = (0, _immutable.fromJS)({
  settings: (_settings = {}, (0, _defineProperty2.default)(_settings, _constants.SAML_SETTINGS, new _SamlSettings.default()), (0, _defineProperty2.default)(_settings, _constants.GET_SSO_ENABLED, false), _settings),
  staged: (0, _defineProperty2.default)({}, _constants.SAML_SETTINGS, (0, _defineProperty2.default)({
    idp: new _IdentityProvider.default()
  }, _constants.EXEMPT_USER_IDS, (0, _immutable.List)()))
});
var GET_SSO_ENABLED_PATH = ['settings', _constants.GET_SSO_ENABLED];
var SAML_SETTINGS_PATH = ['settings', _constants.SAML_SETTINGS];
var SAML_SETTINGS_CONFIRMED_PATH = ['settings', _constants.SAML_SETTINGS, _constants.CONFIRMED_SAML_IDP];
var STAGED_SAML_SETTINGS_PATH = ['staged', _constants.SAML_SETTINGS, 'idp'];
var CURRENT_USER_EXEMPTIONS_PATH = ['settings', _constants.SAML_SETTINGS, _constants.USER_EXEMPTIONS];
var STAGED_EXEMPT_USER_IDS_PATH = ['staged', _constants.SAML_SETTINGS, _constants.EXEMPT_USER_IDS];

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions.ConfirmSamlSettingsActionTypes.SUCCESS, _actions.DeleteSamlSettingsActionTypes.SUCCESS, _actions.FetchSamlSettingsActionTypes.SUCCESS, _actions.UpdateSamlRequirementActionTypes.SUCCESS), function (state, action) {
  var samlSettings = new _SamlSettings.default(action.payload.data);
  var updatedState = state.setIn(SAML_SETTINGS_PATH, samlSettings);
  return updatedState.setIn(STAGED_SAML_SETTINGS_PATH, updatedState.getIn(SAML_SETTINGS_CONFIRMED_PATH)).setIn(STAGED_EXEMPT_USER_IDS_PATH, updatedState.getIn(CURRENT_USER_EXEMPTIONS_PATH).map(function (exemption) {
    return exemption.get(_constants.USER_ID);
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.GetSsoEnabledActionTypes.SUCCESS, function (state, action) {
  return state.setIn(GET_SSO_ENABLED_PATH, action.payload.data[_constants.GET_SSO_ENABLED]);
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveExemptUsersActionTypes.SUCCESS, function (state, action) {
  var updatedState = state.setIn(CURRENT_USER_EXEMPTIONS_PATH, (0, _immutable.List)(action.payload.data.map(function (exemption) {
    return new _UserExemption.default(exemption);
  })));
  return updatedState.setIn(STAGED_EXEMPT_USER_IDS_PATH, updatedState.getIn(CURRENT_USER_EXEMPTIONS_PATH).map(function (exemption) {
    return exemption.get(_constants.USER_ID);
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.SingleSignonStagedActionTypes.CLEAR_STAGED_SAML, function (state) {
  return state.setIn(STAGED_SAML_SETTINGS_PATH, state.getIn(SAML_SETTINGS_CONFIRMED_PATH));
}), (0, _defineProperty2.default)(_handleActions, _actions.SingleSignonStagedActionTypes.UPDATE_SAML_CERTIFICATE, function (state, action) {
  return state.updateIn(STAGED_SAML_SETTINGS_PATH, function (staged) {
    return staged.set(_constants.CERTIFICATE, action.payload);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.SingleSignonStagedActionTypes.UPDATE_SAML_ENTITY, function (state, action) {
  return state.updateIn(STAGED_SAML_SETTINGS_PATH, function (staged) {
    return staged.set(_constants.ENTITY, action.payload);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.SingleSignonStagedActionTypes.UPDATE_SAML_SERVICE, function (state, action) {
  return state.updateIn(STAGED_SAML_SETTINGS_PATH, function (staged) {
    return staged.set(_constants.SERVICE, action.payload);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.ExemptUsersStagedActionTypes.UPDATE_STAGED_EXEMPT_USERS, function (state, action) {
  return state.setIn(STAGED_EXEMPT_USER_IDS_PATH, (0, _immutable.List)(action.payload));
}), (0, _defineProperty2.default)(_handleActions, _actions.ExemptUsersStagedActionTypes.CLEAR_STAGED_EXEMPT_USERS, function (state) {
  return state.setIn(STAGED_EXEMPT_USER_IDS_PATH, state.getIn(CURRENT_USER_EXEMPTIONS_PATH).map(function (exemption) {
    return exemption.get(_constants.USER_ID);
  }));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;